import type { NextPage, GetServerSideProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import { PageTemplate } from '../../components/PageTemplate'
import { Layout } from '../../components/Layout'
import { PageContent, PageConfig } from '../../types/page_component_types'
import { getPagePropsBySlug } from '../../utils/get_page_props_by_slug'
import { extractFaqItems } from '../../utils/extractFaqItems'
import { Locale } from '../../types/shared_types'

const ServicePage: NextPage<{
  pageContent?: PageContent
  pageConfig: PageConfig
  availableLocales?: string[]
}> = ({ pageContent, pageConfig, availableLocales }) => {
  return (
    <Layout
      config={pageConfig}
      meta={pageContent?.meta}
      slug={pageContent?.slug}
      availableLocales={availableLocales}
      faqItems={extractFaqItems(pageContent?.content)}
    >
      <PageTemplate {...pageContent} />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await getPagePropsBySlug(context, '/services')
}

export default ServicePage
